import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./Abituriyentlar.module.css";

const Abituriyentlar = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.container}>
        <div className={classes.content}>
          <h1 className={classes.title}>Abituriyentlarga eslatma</h1>
          
          <div className={classes.section}>
            <p className={classes.greeting}>Hurmatli abituriyentlar!</p>
            
            <p className={classes.intro}>
              Renessans universitetiga o'qishga kirishni istagan talabgorlar quyidagi tartib-qoidalar bilan tanishib chiqishlari lozim.
            </p>
            
            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>1. Ro'yxatdan o'tish tartibi</h2>
              <ul className={classes.documentList}>
                <li>Abituriyentlar Renessans universitetining rasmiy sayti orqali onlayn ariza (<a href="https://qabul.renessans-edu.uz/uz/auth" target="_blank" rel="noopener noreferrer">https://qabul.renessans-edu.uz/uz/auth</a>) topshiradilar.</li>
                <li>Ariza topshirish uchun quyidagi hujjatlar elektron shaklda taqdim etiladi:</li>
              </ul>
              
              <div className={classes.subList}>
                <p>• Pasport nusxasi (JShShIR ko'rsatilgan);</p>
                <p>• O'rta (umumiy), o'rta maxsus yoki kasb-hunar ta'limini tugatganlik haqidagi hujjat.</p>
              </div>
            </div>

            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>2. Qabul jarayoni va imtihonlar</h2>
              <ul className={classes.documentList}>
                <li>Renessans universiteti abituriyentlarni Davlat test markazi (DTM) test sinovlari natijalari asosida yoki ichki kirish imtihonlari orqali qabul qiladi, ichki imtihonlar odatda suhbat, test yoki yozma ish shaklida yo'nalishlar bo'yicha quyidagi fanlardan o'tkaziladi:</li>
              </ul>
              
              <div className={classes.examRequirements}>
                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Boshlang'ich ta'lim"</h4>
                  <p className={classes.examSubjects}>Ona tili va adabiyoti, Matematikadan</p>
                </div>
                
                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Maktabgacha ta'lim", "Psixologiya"</h4>
                  <p className={classes.examSubjects}>Biologiya, Ona tili va adabiyotidan</p>
                </div>
                
                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Tarix"</h4>
                  <p className={classes.examSubjects}>Tarix, Geografiyadan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Milliy g'oya, ma'naviyat asoslari va huquq ta'limi", "Falsafa", "Pedagogika"</h4>
                  <p className={classes.examSubjects}>Tarix, Ona tili va adabiyotidan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Xorijiy til va adabiyoti (ingliz tili)", "Filologiya va tillarni o'qitish (ingliz tili)"</h4>
                  <p className={classes.examSubjects}>Ingliz tili, Ona tili va adabiyotidan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Filologiya va tillarni o'qitish (rus tili)"</h4>
                  <p className={classes.examSubjects}>Rus tili va adabiyoti, Chet tilidan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Filologiya va tillarni o'qitish (o'zbek tili)"</h4>
                  <p className={classes.examSubjects}>O'zbek tili va adabiyoti, Chet tilidan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Iqtisodiyot", "Jahon iqtisodiyoti va xalqaro iqtisodiy munosabatlar", "Moliya va moliyaviy texnologiyalar", "Bank ishi", "Menejment", "Buxgalteriya hisobi", "Soliqlar va soliqqa tortish", "Inson resurslarini boshqarish"</h4>
                  <p className={classes.examSubjects}>Matematika, Chet tilidan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Xalqaro munosabatlar", "Turizm va mehmondo'stlik"</h4>
                  <p className={classes.examSubjects}>Tarix, Chet tilidan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Axborot tizimlari va texnologiyalari", "Sun'iy intellect", "Matematika", "Mehnat muhofazasi va texnika xavfsizligi", "Amaliy matematika", "Geodeziya va geoinformatika", "Kompyuter injiniringi"</h4>
                  <p className={classes.examSubjects}>Matematika, Fizikadan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Filologiya va tillarni o'qitish (Xitoy tili)", "Filologiya va tillarni o'qitish (Koreys tili)"</h4>
                  <p className={classes.examSubjects}>Chet tili, Ona tili va adabiyotidan</p>
                </div>

                <div className={classes.examGroup}>
                  <h4 className={classes.examTitle}>"Dizayn", "Sport faoliyati (faoliyat turlari bo'yicha)"</h4>
                  <p className={classes.examSubjects}>Kasbiy (ijodiy imtihon)</p>
                </div>
              </div>

              <p className={classes.description}>
                Bundan tashqari, majburiy fanlardan (Matematika, Ona tili, O'zbekiston tarixi) sinovlar amalga oshiriladi.
              </p>

              <ul className={classes.documentList}>
                <li>Imtihon natijalari rasmiy e'lon qilinganidan so'ng, talabalikka tavsiya etilganlar belgilangan muddatda shartnoma imzolashlari kerak.</li>
              </ul>
            </div>

            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>3. To'lov-shartnoma tartibi</h2>
              <h3 className={classes.subTitle}>Shartnoma tuzish tartibi</h3>
              <p className={classes.description}>
                Talabalikka qabul qilingan abituriyent bilan oliy ta'lim muassasasi o'rtasida o'qish shartnomasi tuziladi.
              </p>
              <p className={classes.description}>
                Shartnomada quyidagilar ko'rsatiladi:
              </p>
              
              <ul className={classes.contractList}>
                <li>Ta'lim shakli (kunduzgi, kechki, sirtqi);</li>
                <li>O'quv yili davomiyligi;</li>
                <li>To'lov miqdori va uni to'lash muddatlari;</li>
                <li>Tomonlarning huquq va majburiyatlari.</li>
              </ul>

              <h3 className={classes.subTitle}>To'lov miqdori</h3>
              <p className={classes.description}>
                To'lov kontrakt summasi:
              </p>
              <ul className={classes.paymentList}>
                <li>Ta'lim yo'nalishi;</li>
                <li>Ta'lim shakli;</li>
                <li>Mutaxassislik darajasi (bakalavr, magistratura)ga qarab turlicha bo'ladi.</li>
              </ul>

              <h3 className={classes.subTitle}>To'lovni amalga oshirish tartibi</h3>
              <p className={classes.description}>
                To'lov shartnomada ko'rsatilgan bank rekvizitlari orqali amalga oshiriladi.
              </p>
              <p className={classes.description}>
                Talabalar to'lovni:
              </p>
              <ul className={classes.paymentList}>
                <li>bir martalik to'liq; yoki</li>
                <li>bosqichma-bosqich (semestr, chorak yoki oyma-oy) amalga oshirishlari mumkin.</li>
              </ul>

              <h3 className={classes.subTitle}>To'lovni amalga oshirmaslik oqibatlari</h3>
              <ul className={classes.importantNotes}>
                <li>Belgilangan muddatda shartnoma to'lovini amalga oshirmagan talabalar o'qishdan chetlashtirilishi mumkin.</li>
                <li>Talaba kechiktirilgan to'lovni asoslab beradigan ariza bilan murojaat qilsa, OTM qaroriga ko'ra muddat uzaytirilishi mumkin.</li>
              </ul>
            </div>

            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>4. Muhim eslatmalar</h2>
              <ul className={classes.importantNotes}>
                <li>Qabul jarayonida noto'g'ri yoki soxta hujjat topshirgan abituriyentlar abituriyentlik huquqidan mahrum qilinadi.</li>
                <li>O'qishga kirish va o'qish shartlari har bir nodavlat OTM nizomiga asosan belgilanadi.</li>
              </ul>
            </div>

            <div className={classes.procedureSection}>
              <h2 className={classes.sectionTitle}>Qo'shimcha ma'lumotlar uchun</h2>
              <div className={classes.contactInfo}>
                <p><strong>Renessans universiteti rasmiy veb sayti</strong></p>
                <p><strong>Telefon:</strong> 
                  <a href="tel:+998555067007" style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    fontSize: '18px', 
                    fontWeight: '600',
                    color: 'inherit',
                    textDecoration: 'none'
                  }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                    <span>+998 55 506 70 07</span>
                  </a>
                </p>
                <p><strong>E-mail:</strong> <a href="mailto:info@renessans-edu.uz">info@renessans-edu.uz</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Abituriyentlar; 